import FJMenuTab from '../../../common/components/FJMenuTab/FJMenuTab.jsx';
import { AI_GENERATOR_VIDEO_TAB_LIST } from '../../../config/dataConfig/FJAIVideoGeneratorData.js';
import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJActionAIVideoGenerator from '../../../redux/action/FJActionAIVideoGenerator.js';
import styles from './FJHeaderAIVideoGeneratorLandingPage.module.less';
const FJHeaderAIVideoGeneratorLandingPage = () => {
    const dispatch = useDispatch();
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);

    const _onChangeTabIndex = index => {
        const value = menuItems[index].value;

        dispatch(FJActionAIVideoGenerator.changeTabIndexAction(value));
        dispatch(FJActionAIVideoGenerator.toggleModelPickerVisibilityAction(false));
    };

    const menuItems = useMemo(() => {
        return AI_GENERATOR_VIDEO_TAB_LIST.slice(0, 2).map(item => ({
            text: item.name,
            value: item.value,
        }));
    }, []);
    const curIndex = useMemo(() => {
        return menuItems.findIndex(item => item.value === tabIndex);
    }, [menuItems, tabIndex]);
    return (
        <div className={styles.container} id='landing-page-header'>
            <FJMenuTab
                className={styles.menu_tab_box}
                bgInnerClassName={styles.menu_tab_box_bg_inner}
                bgBoxClassName={styles.menu_tab_box_bg}
                textClassName={styles.menu_tab_text}
                tabClassName={styles.menu_tab_box_tab}
                activeClassName={styles.menu_tab_box_active}
                list={menuItems}
                curIndex={curIndex}
                onChange={_onChangeTabIndex}
            />
        </div>
    );
};

export default FJHeaderAIVideoGeneratorLandingPage;
